/*=============================================== Stepper ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";
import Variables from "./Variables";
import { Small } from "./Font";
import Mixins from "./Mixins";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
/*==================== Component ====================*/
var Stepper = function (_a) {
    var steps = _a.steps, _b = _a.direction, direction = _b === void 0 ? "row" : _b, active = _a.active, iconActive = _a.iconActive, _c = _a.fajnyIconActive, fajnyIconActive = _c === void 0 ? "check-solid" : _c, props = __rest(_a, ["steps", "direction", "active", "iconActive", "fajnyIconActive"]);
    return (React.createElement(Container, __assign({ "$direction": direction }, props), steps.map(function (step, i) { return (React.createElement(Item, { "$direction": direction, key: uuid() },
        React.createElement(Number, { "$active": active >= i ? true : false }, active >= i + 1 ? (iconActive ? (React.createElement(Icon, { src: iconActive, size: 16 })) : (React.createElement(FajnyIcon, { name: fajnyIconActive, size: 16 }))) : (i)),
        React.createElement(Text, { as: step.to ? Link : "small", to: step.to }, step.text))); })));
};
export default Stepper;
/*==================== Types ====================*/
var direction = {
    column: "column",
    row: "row",
};
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    ", ";\n\n    &:before {\n        content: \"\";\n        width: ", ";\n        height: ", ";\n        position: absolute;\n        left: 12px;\n        top: 12px;\n        background-color: ", ";\n        z-index: 0;\n    }\n"], ["\n    position: relative;\n    ", ";\n\n    &:before {\n        content: \"\";\n        width: ", ";\n        height: ", ";\n        position: absolute;\n        left: 12px;\n        top: 12px;\n        background-color: ", ";\n        z-index: 0;\n    }\n"])), function (_a) {
    var $direction = _a.$direction;
    return Mixins.Flexbox({
        $align: "flex-start",
        $justify: $direction === "column" ? "flex-start" : "space-between",
        $gap: $direction === "column" ? "l" : "xs",
        $direction: $direction === "row" ? "row" : "column",
    });
}, function (_a) {
    var $direction = _a.$direction;
    return ($direction === "row" ? "calc(100% - 24px)" : "2px");
}, function (_a) {
    var $direction = _a.$direction;
    return ($direction === "row" ? "2px" : "calc(100% - 24px)");
}, Variables.Colors.Primary500);
var Item = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    z-index: 1;\n    ", ";\n    flex-direction: ", ";\n"], ["\n    position: relative;\n    z-index: 1;\n    ", ";\n    flex-direction: ", ";\n"])), function (_a) {
    var $direction = _a.$direction;
    return Mixins.Flexbox({
        $align: "center",
        $justify: $direction === "row" ? "center" : "flex-start",
        $gap: "xxs",
        $inline: true,
    });
}, function (_a) {
    var $direction = _a.$direction;
    return ($direction === "row" ? "column" : "row");
});
var numberSize = 24;
var Number = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n    outline: 2px solid ", ";\n    ", ";\n    font-weight: ", ";\n"], ["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n    outline: 2px solid ", ";\n    ", ";\n    font-weight: ", ";\n"])), numberSize, numberSize, Variables.Radiuses.Circle, function (_a) {
    var $active = _a.$active;
    return ($active ? Variables.Colors.Primary500 : Variables.Colors.Primary300);
}, Variables.Colors.White, Variables.Colors.White, Mixins.Flexbox({
    $inline: true,
    $align: "center",
    $justify: "center",
}), Variables.FontWeights.Black);
var Text = styled(Small)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n    text-decoration: none;\n    color: ", ";\n\n    ", "\n"], ["\n    font-size: ", ";\n    text-decoration: none;\n    color: ", ";\n\n    ", "\n"])), Variables.FontSizes.Small, Variables.Colors.Primary500, function (_a) {
    var to = _a.to;
    return to && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            transition: ", ";\n\n            @media ", " {\n                &:hover {\n                    color: ", ";\n                }\n\n                &:active {\n                    color: ", ";\n                }\n            }\n        "], ["\n            transition: ", ";\n\n            @media ", " {\n                &:hover {\n                    color: ", ";\n                }\n\n                &:active {\n                    color: ", ";\n                }\n            }\n        "])), Variables.Transitions.Short, Variables.Breakpoints.Hover, Variables.Colors.Primary300, Variables.Colors.Primary600);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
